import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CancelReasonsService } from 'src/app/services/core/cancelReason/cancel-reasons.service';
import { TripService } from 'src/app/services/core/distributions/trip/trip.service';
@UntilDestroy()

@Component({
  selector: 'app-cancel-modal',
  templateUrl: './cancel-modal.component.html',
  styleUrls: ['./cancel-modal.component.css']
})
export class CancelModalComponent implements OnInit{
  cancelReason:any;
  cancelReasons: any = [];
  @Input() trip:any;
  @Output() closeModal = new EventEmitter<any>();
  @Output() cancelTripData = new EventEmitter<any>();


  constructor(
    private cancelReasonService: CancelReasonsService,
    private tripService : TripService
  ){}

  ngOnInit(): void {
    this.getCancelReasons();

  }

  getCancelReasons(){
    this.cancelReasonService.get().pipe(untilDestroyed(this)).subscribe((data:any)=>{
      if(data){
        this.cancelReasons = data.results
      }
    })
  }
  onCloseModal(){
    this.closeModal.emit();
  }
  cancelTrip(){

    this.trip['changeReason'] = this.cancelReason.toLowerCase();
    this.trip['status'] = "cancelled";
    this.trip['jobStatus'] = "cancelled";
    this.tripService.createTrip(this.trip, this.trip.id).pipe(untilDestroyed(this)).subscribe((data:any)=>{
      if(data){
        this.cancelTripData.emit(data)
      }
    })
  }
  setReason(reason :any) {
    this.cancelReason = reason;
  }
}
